var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTkChatUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.871 22.3407C50.0645 9.75803 39.2258 0 26.0645 0C22.5806 0 19.3548 0.641976 16.3871 1.92593L51.871 22.3407Z",
    fill: "#D40F7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3871 50.0741C19.3548 51.2296 22.7097 52 26.1935 52C39.3548 52 50.1936 42.242 52 29.6593L16.3871 50.0741Z",
    fill: "#D40F7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0645 5.52099C3.87097 10.2716 0 17.5901 0 25.9358C0 34.2815 3.87097 41.6 10.0645 46.3506V5.52099Z",
    fill: "#D40F7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTkChatUser);
export default __webpack_public_path__ + "static/media/logo-tk-chat-user.bbe468c4bc9997653ed9c043f44994ab.svg";
export { ForwardRef as ReactComponent };